const INTL_LOCALE_OVERRIDES = {
    es_LA: 'es-419',
};
const DAYJS_LOCALE_OVERRIDES = {
    pt_BR: 'pt-br',
    zh_CN: 'zh-cn',
};
export function toIntlLocale(appLocale) {
    var _a;
    return (_a = INTL_LOCALE_OVERRIDES[appLocale]) !== null && _a !== void 0 ? _a : appLocale.replace('_', '-');
}
/** Compares script too, so a Traditional Chinese preference doesn't format dates next to a Simplified Chinese UI. */
function toLanguageAndScript(tag) {
    try {
        const { language, script } = new Intl.Locale(tag).maximize();
        return `${language}-${script}`;
    }
    catch {
        return undefined;
    }
}
/**
 * Prefers the user's own regional variant of the app language (e.g. `en-GB` for an `en_US` UI) so dates follow their
 * regional conventions, falling back to the app locale when none of their preferred languages match it.
 */
export function resolveIntlLocale(appLocale, preferredLocales = []) {
    var _a;
    const appIntlLocale = toIntlLocale(appLocale);
    const appLanguage = toLanguageAndScript(appIntlLocale);
    if (!appLanguage) {
        return appIntlLocale;
    }
    return (_a = preferredLocales.find((tag) => toLanguageAndScript(tag) === appLanguage)) !== null && _a !== void 0 ? _a : appIntlLocale;
}
export function toDayjsLocale(appLocale) {
    var _a;
    return (_a = DAYJS_LOCALE_OVERRIDES[appLocale]) !== null && _a !== void 0 ? _a : appLocale.split(/[-_]/)[0].toLowerCase();
}
export function resolveActiveDateLocales(options) {
    if (!options.localizationEnabled) {
        return {
            intlLocale: undefined,
            dayjsLocale: 'en',
        };
    }
    return {
        intlLocale: resolveIntlLocale(options.appLocale, options.preferredLocales),
        dayjsLocale: toDayjsLocale(options.appLocale),
    };
}
